export const mockPathways = [
  {
    id: 'pw-1',
    slug: 'procure-utility-storage',
    title: 'Procure utility-scale storage',
    goal: 'Successfully procure a grid-scale BESS system',
    audience: 'PRACTITIONER',
    summary: 'From sizing the system to a bankable tender to peers who\'ve done it.',
    icon: '⚡',
    iconBg: 'hsl(48 93% 87%)',
    steps: [
      { id: 'step-1', pillar: 'KNOW', refType: 'TOOL', refId: 'res-1', title: 'Size your system', description: 'Use the BESS calculator to model economics', ctaLabel: 'Open tool', status: 'DONE' },
      { id: 'step-2', pillar: 'LEARN', refType: 'COURSE', refId: 'course-3', title: 'Learn procurement', description: 'Storage Procurement & Tendering course', ctaLabel: 'Start course', status: 'NEXT' },
      { id: 'step-3', pillar: 'KNOW', refType: 'RESOURCE', refId: 'res-3', title: 'Get the tender template', description: 'Model RFP for utility-scale storage', ctaLabel: 'Download', status: 'TODO' },
      { id: 'step-4', pillar: 'CONNECT', refType: 'EXPERT', refId: 'expert-1', title: 'Connect with Lerato', description: 'BESS procurement expert from Eskom', ctaLabel: 'Request intro', status: 'TODO' }
    ]
  },
  {
    id: 'pw-2',
    slug: 'digitise-distribution-utility',
    title: 'Digitise a distribution utility',
    goal: 'Build a roadmap for utility digital transformation',
    audience: 'PRACTITIONER',
    summary: 'SCADA/ADMS fundamentals, a readiness check, and a practitioner cohort.',
    icon: '📡',
    iconBg: 'hsl(195 35% 93%)',
    steps: [
      { id: 'step-5', pillar: 'LEARN', refType: 'COURSE', refId: 'course-2', title: 'Take the digitization course', description: 'Utility Digitisation Pathways', ctaLabel: 'Start learning', status: 'TODO' },
      { id: 'step-6', pillar: 'KNOW', refType: 'TOOL', refId: 'res-6', title: 'Assess your readiness', description: 'Self-assessment checklist', ctaLabel: 'Start assessment', status: 'TODO' },
      { id: 'step-7', pillar: 'CONNECT', refType: 'SPACE', refId: 'space-2', title: 'Join the digitization space', description: 'Discuss with peers and experts', ctaLabel: 'Join space', status: 'TODO' }
    ]
  },
  {
    id: 'pw-3',
    slug: 'connect-mini-grid',
    title: 'Connect a community mini-grid',
    goal: 'Deploy a solar-storage mini-grid project',
    audience: 'PRACTITIONER',
    summary: 'Design references, financing models, and operators in your region.',
    icon: '🌍',
    iconBg: 'hsl(150 40% 90%)',
    steps: [
      { id: 'step-8', pillar: 'LEARN', refType: 'COURSE', refId: 'course-4', title: 'Mini-grid fundamentals', description: 'Development from site to commissioning', ctaLabel: 'Start course', status: 'TODO' },
      { id: 'step-9', pillar: 'KNOW', refType: 'RESOURCE', refId: 'res-5', title: 'Review regulatory framework', description: 'Policy guide for your region', ctaLabel: 'Read guide', status: 'TODO' },
      { id: 'step-10', pillar: 'CONNECT', refType: 'SPACE', refId: 'space-3', title: 'Network with operators', description: 'Mini-grids Africa community', ctaLabel: 'Join space', status: 'TODO' }
    ]
  },
  {
    id: 'pw-4',
    slug: 'browse-project-showcases',
    title: 'Browse open project showcases',
    goal: 'Discover co-investment opportunities',
    audience: 'INVESTOR',
    summary: 'GOTF & BESS Consortium projects flagged open for co-investment.',
    icon: '🌍',
    iconBg: 'hsl(150 40% 90%)',
    steps: [
      { id: 'step-11', pillar: 'KNOW', refType: 'SHOWCASES', refId: null, title: 'Review project pipeline', description: 'Filter by mandate and region', ctaLabel: 'View projects', status: 'TODO' },
      { id: 'step-12', pillar: 'KNOW', refType: 'RESOURCE', refId: 'res-4', title: 'Check market benchmarks', description: 'Latest pricing and trends', ctaLabel: 'View intel', status: 'TODO' },
      { id: 'step-13', pillar: 'CONNECT', refType: 'EXPERT', refId: 'expert-5', title: 'Connect with developers', description: 'Reach project sponsors', ctaLabel: 'Request intro', status: 'TODO' }
    ]
  }
];
